{
  "invitations_active_one": "{{count}} Active Invitation",
  "invitations_active_other": "{{count}} Active Invitations",
  "invitation": {
    "respond": "Respond",
    "status": {
      "ready_to_accept": "Ready To Accept",
      "consideration": "Under Consideration"
    },
    "team_invitation": {
      "view_profile": "View Profile"
    },
    "relief_listing_request": {
      "view_listing": "View Listing",
      "position_title": "{{title}} - {{employer}}"
    }
  },
  "links": {
    "specialities": "Specialities",
    "specialities_description": "Create, edit or view your specialities.",
    "profile": "Profile",
    "profile_description": "View or edit your profile.",
    "classes": "Classes",
    "classes_description": "Create and view classes.",
    "teams": "Teams",
    "teams_description": "Create, edit or join a team.",
    "timetable": "Timetable",
    "timetable_description": "Setup your timetable priorities.",
    "measurement_and_feedback": "Measurement and Feedback",
    "measurement_and_feedback_description": "View your feedback.",
    "learning_enhancement_technologies": "Learning Enhancement Technologies",
    "learning_enhancement_technologies_description": "Explore and utilise learning enhancement technologies.",
    "relief_listings": "Relief Listings",
    "relief_listings_description": "Create listings to find cover for your classes.",
    "relief_bookings": "Relief Bookings",
    "relief_bookings_description": "View all the classes you're covering."
  }
}
